import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function AddNote({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>AddNote</title>
      <path
        d="M20 14L20.5087 14.5511C20.6625 14.4091 20.75 14.2093 20.75 14H20ZM13.5 20V20.75C13.6885 20.75 13.8702 20.679 14.0087 20.5511L13.5 20ZM12 3.25C11.5858 3.25 11.25 3.58579 11.25 4C11.25 4.41421 11.5858 4.75 12 4.75V3.25ZM4.75 12C4.75 11.5858 4.41421 11.25 4 11.25C3.58579 11.25 3.25 11.5858 3.25 12H4.75ZM19.25 7V14H20.75V7H19.25ZM13.5 19.25H7V20.75H13.5V19.25ZM19.4913 13.4489L12.9913 19.4489L14.0087 20.5511L20.5087 14.5511L19.4913 13.4489ZM14.25 20V16H12.75V20H14.25ZM15.5 14.75H20V13.25H15.5V14.75ZM12 4.75H17V3.25H12V4.75ZM4.75 17V12H3.25V17H4.75ZM14.25 16C14.25 15.3096 14.8096 14.75 15.5 14.75V13.25C13.9812 13.25 12.75 14.4812 12.75 16H14.25ZM7 19.25C5.75736 19.25 4.75 18.2426 4.75 17H3.25C3.25 19.0711 4.92893 20.75 7 20.75V19.25ZM20.75 7C20.75 4.92893 19.0711 3.25 17 3.25V4.75C18.2426 4.75 19.25 5.75736 19.25 7H20.75Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M7 4V7M7 10V7M7 7H4M7 7H10"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
